<template>
  <span class="status-badge" :class="variant">{{ label }}</span>
</template>

<script>
export default {
  name: 'StatusBadge',
  props: {
    status: { type: String, required: true, validator: v => ['pending', 'confirmed'].includes(v) }
  },
  computed: {
    variant() { return this.status },
    label() { return this.status === 'confirmed' ? 'Confirmado' : 'Pendente' }
  }
}
</script>

<style scoped>
.status-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: var(--text-xs);
  font-weight: 600;
  white-space: nowrap;
}
.pending { background: #ead994; color: #856404; }
.confirmed { background: #95eab8; color: #155724; }
</style>
